/**
 * JavaScript for Hero Video
 */

document.addEventListener('DOMContentLoaded', function() {
    const videoContainers = document.querySelectorAll('.gg-case-study-full-width-video__video-container');
    
    videoContainers.forEach(container => {
        const iframe = container.querySelector('.gg-case-study-full-width-video__video');
        if (iframe) {
            // Listen for iframe load event
            iframe.addEventListener('load', function() {
                // Add loaded class when video iframe has loaded
                container.classList.add('video-loaded');
            });
            
            // Fallback: If iframe is already loaded (cached), add class immediately
            if (iframe.complete) {
                container.classList.add('video-loaded');
            }
        }
    });
});
